import  orderBy from "lodash/orderBy";

import dynamic from "next/dynamic";
const OperationUnitCard = dynamic(() =>
  import("components/operationUnits/card/OperationUnitCard")
);

import styles from "./operationUnits.page.module.scss";
import StoresHeader from "components/operationUnits/header/StoresHeader";
import StoresSearch from "components/operationUnits/search/StoresSearch";
import {useEffect, useState} from "react";
import {chain, deburr} from "lodash";
import {arrayToPath, queryToQueryString} from "../../grandus-lib/hooks/useFilter";
import get from "lodash/get";
import {reqGetHeadersFront, reqGetHost} from "../../grandus-lib/utils";
import find from "lodash/find";


const Stores = ({ operationUnits, campaigns, campaignsTitle, storesMap }) => {
  const [search, setSearch] = useState('');
  const [filteredOperationUnits, setFilteredData] = useState(operationUnits);

  useEffect(() => {
    if (search.length > 2) {
      const filter = operationUnits.filter(unit => {
        return (
            deburr(unit?.name.toLowerCase())
                .includes(
                    deburr(search.toLowerCase())
                )
            || deburr(unit?.town?.name.toLowerCase())
                .includes(
                    deburr(search.toLowerCase())
                )
            || deburr(unit.town?.district?.county?.name.toLowerCase())
                .includes(
                    deburr(search.toLowerCase())
                )
            || unit.zip.replace(/\s/g, '').includes(search.replace(/\s/g, ''))
        );
      });
      setFilteredData(filter);
    } else {
      setFilteredData(operationUnits);
    }
  }, [search]);

  const sortedOperationUnits = orderBy(filteredOperationUnits, "town.name", "asc");
  return (
    <main className={styles.operationUnitContainer}>
      <StoresHeader storesMap={storesMap} campaignsTitle={campaignsTitle} campaigns={campaigns} />

      <section className="products">
        <div className="product-listing-grid container">
          <div className="row">
            <div className="col-12">
              <StoresSearch
                  search={search}
                  setSearch={setSearch}
                  counties={chain(operationUnits).map('town.district.county.name').uniq().sort().value()}
              />
            </div>
          </div>
          <div className="row">
            {sortedOperationUnits.map((operationUnit) => (
                <div
                    className="col-xl-3 col-md-6 col-sm-12 column"
                    key={`operation-unit-${operationUnit?.id}`}
                >
                  <OperationUnitCard {...operationUnit} />
                </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export async function getServerSideProps(context) {
    const url = `${reqGetHost(
        context?.req
    )}/api/lib/v1/campaigns?perPage=3`;

    const { campaigns } = await fetch(url, {
        headers: reqGetHeadersFront(context?.req, {
            forwardUrl: context?.resolvedUrl,
        }),
    }).then((result) => {
        return result.json();
    });

    const staticBlocks = await fetch(
        `${reqGetHost(context?.req)}/api/lib/v1/blocks?expand=photo`,
        {
            headers: reqGetHeadersFront(context?.req, {
                forwardUrl: context?.resolvedUrl,
            }),
        }).then((response) => response.json());

    const { operationUnits } = await fetch(
        `${reqGetHost(context?.req)}/api/lib/v1/operation-units?perPage=100`,
        {
            headers: reqGetHeadersFront(context?.req, {
                forwardUrl: context?.resolvedUrl,
            }),
        }).then((response) => response.json());

    return {
        props: {
            campaignsTitle: find(staticBlocks, ['hash', 'akcie']),
            storesMap: find(staticBlocks, ['hash', 'PredajneMapaText']),
            campaigns,
            operationUnits
        },
    };
}

export default Stores;
